module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/en/keith-b376aa062a2af7401599326f7944cdbf.jpg";